import LockIcon from '@mui/icons-material/Lock';
import { TableHeadCell } from '@ovComponents/2-component/table/table';
import { Box, Tooltip } from 'hephaestus/web';
import { useTranslation } from 'react-i18next';
import { TESTID_PORTFOLIO_WIDGET_HOLDINGS_TABLE_HEAD_CELL } from '../portfolioTestIds';
import type { PortfolioSubAccount } from './interfaces';
import TaxRank from './taxRank';
import {
  getPortfolioMemberColumnSx,
  getPortfolioPairedMemberColumnSx,
} from './utils';

export const SubAccountTableHeadCell = ({
  subAccount,
  index = 0,
  pairedWithCustomTarget = false,
}: {
  subAccount: PortfolioSubAccount;
  index?: number;
  pairedWithCustomTarget?: boolean;
}) => {
  const { t } = useTranslation(['components', 'accountTypes']);

  return (
    <TableHeadCell
      sx={
        pairedWithCustomTarget
          ? getPortfolioPairedMemberColumnSx(subAccount.name)
          : getPortfolioMemberColumnSx(subAccount.name)
      }
      headLabelSx={{ whiteSpace: 'nowrap' }}
      data-testid={TESTID_PORTFOLIO_WIDGET_HOLDINGS_TABLE_HEAD_CELL(index)}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'start',
          alignItems: 'center',
        }}
      >
        <TaxRank taxRank={subAccount.taxRank ?? 0} />
        {subAccount.name}
        {!!subAccount.inactive && (
          <Tooltip title={t('portfolioTable.subAccountIsInactive')}>
            <LockIcon
              sx={{
                verticalAlign: 'text-top',
                fontSize: '14px',
                color: 'inherit',
              }}
            />
          </Tooltip>
        )}
      </Box>
    </TableHeadCell>
  );
};
